import { replaceUnderscores } from "~/common/utils";
import { CompletedMultiCheckAnswer } from "~/common/utils/consultations/shared";

export const formatMultiCheckAnswers = (answer: CompletedMultiCheckAnswer[]) =>
  answer.flatMap((answer) => [
    ...(answer.values?.map((valueObj) => replaceUnderscores(valueObj.value)) ??
      []),
    ...(answer.extra_data ? [answer.extra_data] : []),
  ]);
